module.exports = __webpack_public_path__ + "img/AvenirLTStd-Medium.6750cfaa.svg";